// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/bonusprogram-" + chunkId + "." + {"1":"3ab85b2f","2":"b3100116","3":"6abd64c9","4":"12ce7cc9","5":"8867f17e"}[chunkId] + ".js";
};